/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membersenable1Inputs */

const en_membersenable1 = /** @type {(inputs: Membersenable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn on memberships`)
};

const de_membersenable1 = /** @type {(inputs: Membersenable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitgliedschaft aktivieren`)
};

/**
* | output |
* | --- |
* | "Turn on memberships" |
*
* @param {Membersenable1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersenable1 = /** @type {((inputs?: Membersenable1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersenable1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersenable1(inputs)
	return de_membersenable1(inputs)
});
export { membersenable1 as "membersEnable" }